// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxOrRadio_container__rreqK","input":"CheckboxOrRadio_input___7u3G"};